import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import nexapi from '../../services/api';
import { CategoryModel } from '../../types/models/CategoryModel';


interface CategoryResponse{
  data: CategoryModel[];
  totalCount: number;
}

interface CategoryState {
  data: CategoryModel[];
  totalRecords: number;
  currentPage: number;
  loading: boolean;
  error: string | null;
  status: string | null;
}

const initialState: CategoryState = {
  data: [],
  totalRecords: 0,
  currentPage: 1,
  loading: false,
  error: null,
  status: null
};

const API_URL = '/PettyCash';

export const fetchCategory = createAsyncThunk<CategoryResponse, {
  filters: Record<string, any>; 
  page: number; 
  numberOfRecord: number; 
  userId: string;
  sortColumn?: string;
  sortOrder?: 'asc' | 'desc';
  companyId:string;
   iscompanySubype : boolean;
 }>(
  'pettyCashCategory/fetchCategory',
  async ({filters, page, numberOfRecord, userId, sortColumn = '', sortOrder = 'asc', companyId,iscompanySubype }) => {
    try {
        
      // Construct the query string with filters
      const searchUnit =  filters.search || "";
      const url = `${API_URL}/GetCategory?pagination=true&page=${page}&numberOfRecord=${numberOfRecord}&userId=${userId}&companyId=${companyId}&search=${searchUnit}&sortColumn=${sortColumn}&sortOrder=${sortOrder}&state=${filters.state}&userTimeZone=${filters.userTimeZone}&isCompanyCategory=${iscompanySubype}`;

      const response = await nexapi.post(url);
    const data = response.data;
      if (Array.isArray(data?.data)) {
        return {
          data: data.data,
          totalCount: data.totalCount, 
        };
      } else {
        console.error('Invalid API Response:', data);
        return { data: [], totalCount: 0 }; // Return a fallback structure
      }
    } catch (error) {
      console.error('API Call Failed:', error);
      throw error;
    }
  }
);

export const deleteApplication = createAsyncThunk<CategoryResponse, { Id : string, UserId:string,reason: string}>(
  'pettyCashDivision/deleteApplication',
  async ({ Id,UserId,reason}) => {
    
    try {
      const [cleanId] = Id.includes('_') ? Id.split('_') : [Id];

      const payload = {
        Id: cleanId,
        UserId: UserId,
        reason: reason
      };
      const url = API_URL+"/ActivateCategory";
      const method = "post";
      const response = await nexapi[method](url, payload);

      
      response.data.statusCode = "200";
      return response.data.statusCode;
    } catch (error) {
      console.error('API Call Failed:', error);
      throw error;
    }
  }
);

const requestsSlice = createSlice({
  name: 'pettyCashCategory',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.status = 'succeeded';
      })
      .addCase(fetchCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch Branch';
      })
      .addMatcher(
        (action) => action.type.endsWith('/pending'),
        (state) => {
          state.status = 'loading';
        }
      )
      .addMatcher(
        (action) => action.type.endsWith('/rejected'),
        (state, action) => {
          state.status = 'failed';          
        }
      );
  },
});

export default requestsSlice.reducer;